export const MOBILE_BREAKPOINT = 613;

export const DMS_MIN_WIDTH = 992;
